module.exports = __webpack_public_path__ + "img/logo.350d2925.svg";